<template>
	<div class="study-calendar">
		<div class="row text-align-center padding">
			<span class="col"> <i class="icon icon-prev"></i> </span>
			<span class="col">{{2020}}.04</span>
			<span class="col"> <i class="icon icon-next"></i> </span>
		</div>		

		<div class="data-table card row">
			<table>
				<thead>
					<tr>
						<th class="label-cell text-color-red">일</th>
						<th class="label-cell">월</th>
						<th class="label-cell">화</th>
						<th class="label-cell">수</th>
						<th class="label-cell">목</th>
						<th class="label-cell">금</th>
						<th class="label-cell text-color-blue">토</th>
					</tr>
				</thead>
				<tbody>
					<!--
					<tr v-for="(item, i) in weekCount" :key="'i'+i">						
						<td v-for="(subitem, j) in dayCount" :key="'j'+j" :class="{'text-color-red' : j==0}">
							{{getDays()}}
						</td>			
				 	</tr>
					 -->
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		weekCount: {type: Number, default: 4},
		dayCount: {type: Number, default: 7},
		
	},
	data() {
				
		return {
			year: moment().year(),
			month: moment().month()+1,
			dateList: []
		}
	}, 
	mounted() {
		const _this = this;
		_this.showCalendar();
	},
	methods: {
		getDays() {
			const _this = this;
			day += 1;				
			return day;
		},
		showCalendar() {
			const _this = this;
	
		}
	}
}
</script>